import React from 'react';
import { PlaidLink } from 'react-plaid-link';

import GGApi from '../../../utils/GGApi';
import Plaid_oauth from '../../Financial_account_components/Link_destination/callback_oauth/Plaid_oauth';
import plaid_logo from '../../../images/stripe_imgs/plaid.svg';
import {
    cleanupPlaidOauthStorage,
    finishInstantBankAdd,
} from './instantBankShared';

/**
 * Extracted from Payment_methods so FC can coexist without deleting Plaid code.
 * Instant bank collection via Plaid Link (legacy fallback).
 */
export default class InstantBankPlaid extends React.Component {
    constructor(props) {
        super(props);
        this.handlePlaidSuccess = this.handlePlaidSuccess.bind(this);
        this.handlePlaidLoad = this.handlePlaidLoad.bind(this);
        this.handlePlaidExit = this.handlePlaidExit.bind(this);
    }

    componentDidMount() {
        if (this.props.plaid_link_token && this.props.plaid_session) {
            this.props.setParentState({
                plaid_link_token: this.props.plaid_link_token,
                plaid_session: this.props.plaid_session,
                verification: 'Instant',
            });
        }
    }

    handlePlaidLoad() {}

    handlePlaidSuccess(public_token, metadata) {
        this.props.setParentState({ loading: true });

        GGApi.bank_create(null, null, true, public_token, metadata.accounts[0].id).then((response) => {
            if (response.success) {
                finishInstantBankAdd({
                    response,
                    bankNext: this.props.bankNext,
                    setState: this.props.setParentState,
                    cleanupFn: () => cleanupPlaidOauthStorage(this.props.cleanupOauth),
                });
            } else {
                if (response.message === 'A bank account with this information already exists for your use. Please add a different bank account.') {
                    alert(response.message);
                } else {
                    alert('The server has encountered a problem. Please try again, or select a different payment method.');
                }
                this.props.setParentState({ loading: false });
            }
        });
    }

    handlePlaidExit(err) {
        cleanupPlaidOauthStorage(this.props.cleanupOauth);
        this.props.setParentState({
            plaid_link_token: null,
            plaid_session: null,
            verification: '',
            loading: false,
        });
        if (err !== null) {
            console.log(err);
        }
    }

    renderPlaidLink() {
        if (!this.props.plaid_link_token || this.props.verification !== 'Instant') {
            return null;
        }
        return (
            <div className="button_container" style={{ position: 'static', margin: '24px 0px' }}>
                <PlaidLink
                    token={this.props.plaid_link_token}
                    onLoad={this.handlePlaidLoad}
                    onSuccess={this.handlePlaidSuccess}
                    onExit={this.handlePlaidExit}
                    style={{
                        width: '100%',
                        padding: '0.875rem 1rem',
                        borderRadius: '5px',
                        border: 'none',
                        background: '#FFD700',
                    }}
                >
                    Connect a bank account with Plaid
                </PlaidLink>
            </div>
        );
    }

    renderOAuthResume() {
        if (!this.props.plaid_link_token || !this.props.plaid_session) {
            return null;
        }
        return (
            <div className="button_container" style={{ position: 'static', margin: '24px 0px' }}>
                <Plaid_oauth
                    token={this.props.plaid_link_token}
                    onSuccess={this.handlePlaidSuccess}
                    onLoad={this.handlePlaidLoad}
                    onExit={this.handlePlaidExit}
                    receivedRedirectUri={this.props.plaid_session}
                />
            </div>
        );
    }

    render() {
        if (this.props.oauthResumeOnly) {
            return this.renderOAuthResume();
        }
        return this.renderPlaidLink();
    }
}

/** Instant verification tab button (Plaid branding). */
export function InstantBankPlaidTab({ verification, onSelect }) {
    return (
        <div onClick={onSelect}
            className={verification === 'Instant' ? 'click_button_selected click_button' : 'click_button'}>
            <p className="bold">Instant Verification</p>
            <p className="small_text">Sign in to your bank to instantly verify your bank account</p>
            <div className="powered_by_plaid">
                <p className="tiny_text">Powered by </p>
                <img src={plaid_logo} alt="Plaid" />
            </div>
        </div>
    );
}
